<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <mat-form-field>
        <mat-label>Select</mat-label>
        <mat-select [(ngModel)]="selectedValue">
            @for (code of data.codes; track code) {
            <mat-option [value]="code.snomedDisplay">{{code.snomedDisplay}}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button type="button" mat-button (click)="closeDialog()">Cancel</button>
    <button type="button" mat-button (click)="closeDialog()" cdkFocusInitial>Ok</button>
</mat-dialog-actions>